<template>
  <div class="contain">
    <h4 class="title">会议详情</h4>
    <el-card>
      <div class="mianMessage">
        <h4>共识的会议</h4>
        <p class="position">
          执笔人:王建 苏晓彤 王霞时 金源礼 武宣以 王继贵 黄健中 李莉莉
        </p>
      </div>
    </el-card>
    <el-card class="el-cards">
      <div class="l_1 left1">
        <div class="groups">
          <h5>参会专家</h5>
          <p>孙晓宇 李思慧 王小源</p>
        </div>
        <div class="groups">
          <h5>共识投票</h5>
          <p>暂无稿件</p>
        </div>
        <div class="groups">
          <h5>参考文献</h5>
          <p>暂无稿件</p>
        </div>
      </div>
      <div class="l_1 left2">
        <div class="groups">
          <h5>备注</h5>
          <p>
            1. 先天性色素痣中增生结节的基因学改变及生物学潜能 2.
            中国间变性淋巴瘤激酶阳性、ROS1阳性非小细胞肺 癌诊疗指南
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title {
    color: #212529;
    font-size: 28px;
    padding-bottom: 21px;
    border-bottom: 1px solid #e8e8e8;
  }
  .el-card {
    margin-top: 23px;
    .mianMessage {
      h4 {
        color: #212529;
      }
      .position {
        font-size: 13px;
        color: #212529;
        margin-top: 40px;
        margin-bottom: 20px;
      }
    }
  }
  .el-cards {
    flex: 1;
    /deep/.el-card__body {
      display: flex;
      height: 100%;
      justify-content: space-between;
    }
    .l_1 {
      width: 48%;
      height: 100%;
      border: 1px solid #f0f0f0;
      padding: 0 25px;
      h5 {
        color: #212529;
        font-size: 16px;
      }
      p {
        color: #212529;
        font-size: 13px;
        margin-top: 23px;
        line-height: 24px;
      }
    }
    .left1 {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .left2 {
      .groups {
        margin-top: 23px;
      }
    }
  }
}
</style>
